import React from "react";
import {
  Card,
  List,
  Avatar,
  Typography,
  Button,
  Row,
  Col,
  Empty,
  Grid,
} from "antd";
import { BellOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../contexts/NotificationContext";
import { useUser } from "../contexts/UserContext";

const { Text, Title } = Typography;
const { useBreakpoint } = Grid;

const Notification = () => {
  const { notifications, markAllAsRead, markAsRead } = useNotifications();
  const navigate = useNavigate();
  const { currentUser } = useUser();
  const screens = useBreakpoint();

  if (notifications?.length === 0) {
    return (
      <div style={{ textAlign: "center", padding: "50px 16px" }}>
        <Empty description="No notifications available" />
      </div>
    );
  }

  const handleNotificationClick = (
    notificationId,
    order,
    isRead,
    orderCompleted,
  ) => {
    if (!isRead) {
      markAsRead(notificationId);
    }
    if (orderCompleted) {
      navigate(`/notification/${order._id}`);
    } else {
      const { seller } = order;
      if (seller._id === currentUser._id) {
        navigate(`/sell/order?orderId=${order._id}`);
      } else {
        navigate(`/buy/order?orderId=${order._id}`);
      }
    }
  };

  // Responsive Header Title Component
  const cardTitle = (
    <Row justify="space-between" align="middle" gutter={[8, 8]}>
      <Col style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <BellOutlined style={{ fontSize: "18px" }} />
        <Title level={5} style={{ margin: 0, fontSize: "16px" }}>
          Notifications
        </Title>
      </Col>
      <Col>
        <Button
          type="link"
          onClick={markAllAsRead}
          style={{ padding: 0, height: "auto" }}
        >
          Mark all as read
        </Button>
      </Col>
    </Row>
  );

  return (
    <div
      style={{
        maxWidth: "800px",
        margin: screens.xs ? "16px auto" : "50px auto",
        padding: screens.xs ? "0 12px" : "0 16px",
      }}
    >
      <Card
        title={cardTitle}
        variant={false}
        style={{ boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
        bodyStyle={{ padding: 0 }}
      >
        <List
          itemLayout="vertical"
          dataSource={notifications}
          renderItem={(item) => (
            <List.Item
              style={{
                backgroundColor: item.isRead ? "#fff" : "#fff7f6",
                padding: screens.xs ? "12px 16px" : "20px",
                borderBottom: "1px solid #f0f0f0",
                cursor: "pointer",
              }}
              onClick={() =>
                handleNotificationClick(
                  item._id,
                  item.order,
                  item.isRead,
                  item.orderCompleted,
                )
              }
            >
              <Row gutter={[12, 12]} align="middle" wrap={false}>
                <Col flex="none">
                  <Avatar
                    shape="circle"
                    size={screens.xs ? 48 : 64}
                    src={
                      item.order?.seller?._id === currentUser._id
                        ? item.order?.user?.photoUrl || "/default-avatar.png"
                        : item.order?.seller?.photoUrl || "/default-avatar.png"
                    }
                    style={{
                      objectFit: "cover",
                    }}
                  />
                </Col>
                <Col flex="auto" style={{ minWidth: 0 }}>
                  <Text strong style={{ display: "block", fontSize: "14px" }}>
                    {item.message}
                  </Text>
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    {new Date(item.createdAt).toLocaleString()}
                  </Text>
                </Col>
              </Row>
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
};

export default Notification;
